/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgObjectDetection = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <path
        d="M2 2h7v2H4v5H2V2zm18 2h-5V2h7v7h-2V4zm-8 1.586L18.414 12 12 18.414 5.586 12 12 5.586zM8.414 12 12 15.586 15.586 12 12 8.414 8.414 12zM2 15h2v5h5v2H2v-7zm18 5v-5h2v7h-7v-2h5z"
        fill="currentcolor"
      />
    </g>
  </Icon>
);
export { SvgObjectDetection as ObjectDetection };
